module.exports = __webpack_public_path__ + "img/filmi_logo_bl_beta.def91433.svg";